import React, { useState } from 'react';
import { DurationSelection } from './DurationSelection';
import { TimeSlotSelection } from './TimeSlotSelection';

export const BookingWizard = ({ 
    handleSlotClick, 
    selectedDuration, 
    setSelectedDuration, 
    removeSelectedSlot,
    sessionDurations,
    selectedDate,
    tutorId,
    selectedSlot,
    filteredSlots, // Receive filtered slots
    isLoadingSlots // Receive loading state
}) => {
    const [goSteps, setGoSteps] = useState(0);

    const handleDurationSelect = (slot) => {
        setSelectedDuration(slot);
        removeSelectedSlot();
    };

    const handleNextStep = () => {
        if (goSteps === 0) {
            setGoSteps(1);
        }
    };

    const handlePrevStep = () => {
        if (goSteps === 1) {
            setGoSteps(0);
            removeSelectedSlot();
        }
    };

    return (
        <div className="row h-100">
            <div className="col-xl-12 col-xxl-12">
                <div className="card">
                    <div className="form-wizard">
                        {goSteps === 0 && (
                            <DurationSelection 
                                selectedDuration={selectedDuration} 
                                onSelectDuration={handleDurationSelect} 
                                sessionDurations={sessionDurations}
                            />
                        )}

                        {goSteps === 1 && (
                            <TimeSlotSelection
                                selectedDuration={selectedDuration}
                                selectedDate={selectedDate}
                                handleSlotClick={handleSlotClick}
                                tutorId={tutorId}
                                selectedSlot={selectedSlot}
                                filteredSlots={filteredSlots} // Pass to TimeSlotSelection
                                isLoadingSlots={isLoadingSlots} // Pass loading state
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className="row align-items-end">
                <div className="col-auto ms-auto">
                    <div className="d-flex gap-2">
                        {goSteps === 1 && (
                            <button
                                className="btn btn-secondary sw-btn-prev"
                                onClick={handlePrevStep}
                            >
                                Prev
                            </button>
                        )}
                        {goSteps == 0 && (
                            <button
                                className="btn btn-primary sw-btn-next"
                                onClick={handleNextStep}
                                disabled={!selectedDuration}
                            >
                                Next
                            </button>
                        )}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default BookingWizard;